import { selectedConfigurationSchema } from "@/lib/schema/configuration/configuration";
import z from "zod";



export const editProjectSchema = z.object({
    name: z.string({ required_error: 'Name is required' }),
    challenge: z.string({ required_error: "Description is required" }),

    crm_system: z.string().optional().nullable(),
    crm_id: z.string().optional().nullable(),
    crm_project_id: z.number().optional().nullable(),

    selected_configuration: selectedConfigurationSchema.optional().nullable(),
});
